import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';

const english = {
  title: 'Image source',
  titleInputHeading: 'Title',
  titleInputPlaceholder: 'Image title',
  durationInputHeading: 'Duration',
  save: 'Save',
  cancel: 'Cancel',
  maxDuration: 'Maximum: 3 minutes',
};

const welsh = {
  title: 'Ffynhonnell delwedd',
  titleInputHeading: 'Teitl',
  titleInputPlaceholder: 'Teitl delwedd',
  durationInputHeading: 'Hyd',
  save: 'Cadw',
  cancel: 'Canslo',
  maxDuration: 'Mwyafswm: 3 munud',
};

export const addImageNodeWizardText: any = getLocalizationBasedOnLang(
  english,
  welsh,
);
